import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class AdminListDecline extends React.Component {

	render() {
		const { content: { hostName, listId, listTitle, logo, reason, siteName } } = this.props;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Bonjour {hostName},
					</div>
					<EmptySpace height={20} />
					<div>
						Malheureusement, votre annonce a été refusée par l'administrateur. Veuillez vérifier la raison du refus, mettre à jour les détails et la soumettre à nouveau pour approbation.
					</div>
					<EmptySpace height={20} />
					<div style={marginBottom}><span style={fontWeightBold}>Détails de l'annonce :</span></div>
					<div style={marginBottom}><span style={fontWeightBold}>ID :</span> {listId}</div>
					<div style={marginBottom}><span style={fontWeightBold}>Titre :</span> {listTitle}</div>
					<div><span style={fontWeightBold}>Raison du refus :</span> {reason}</div>
					<EmptySpace height={20} />
					<div>
						N'hésitez pas à nous contacter si vous avez besoin d'aide.
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default AdminListDecline;